export default "__VITE_ASSET__Du9MkKVz__"